import { FC } from 'react';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { useTranslationAPI } from '../../../../translations';
import { jobModuleCodes } from '../../../../../data/translations/jobModuleCodes';
import useSearchParams from '../../../../../hooks/useSearchParams';
import RouteLink from '../../../../../components/RouteLink';

type SearchParams = { sourcejobboardinstanceguid?: string };

export const PublicJobDetailApplyButton: FC = () => {
	const { translate } = useTranslationAPI();
	const {
		data: { applyUrl },
		isLoading,
	} = usePublicJobDetailDataQuery();
	const { sourcejobboardinstanceguid: sourceJobBoardInstanceGuid }: SearchParams = useSearchParams({
		caseInsensitive: true,
	});

	let newApplyUrl = applyUrl;

	if (applyUrl && sourceJobBoardInstanceGuid) {
		const url = new URL(applyUrl);

		const params = new URLSearchParams(url.search);

		params.append('sourceJobBoardInstanceGuid', sourceJobBoardInstanceGuid);

		url.search = params.toString();

		newApplyUrl = url.toString();
	}

	return (
		<RouteLink
			size='small'
			styledButton
			primary
			block
			href={newApplyUrl}
			disabled={isLoading}
		>
			{translate(jobModuleCodes.applyForJob)}
		</RouteLink>
	);
};
